SupportBasePresentation = require('./base')
SupportGPassStatusAndNotesPresentation = require('./gpass_messages')

class SupportGPassPresenterPresentation extends SupportBasePresentation
	getLookupObject: () ->
		SupportGPassStatusAndNotesPresentation

module.exports = SupportGPassPresenterPresentation
